module.exports = __webpack_public_path__ + "media/images/icons/swiper-arrow-rigth-3d289c500f7e62849d82ad9c30de9c87.svg";